/* WS-state change notifications (F4 item 3 — store decoupling).
 *
 * NOT a port — the old app had no such signal at all; a WS data change
 * (refresh() re-fetching the board, the optimistic paint/rollback around a
 * status change in ws/board.ts's statusMenu, WS.init() finishing its
 * fetch) triggered a HARDCODED list of render calls
 * (renderActions/renderExec/renderConflicts/renderStrip[/renderNotesCard]),
 * duplicated between `repaintAll()` and the tail of `init()`
 * (state/workspace.ts). This module is the seam that replaces that list:
 * state/workspace.ts calls `notifyWsChange()` wherever it used to call the
 * fan-out directly, and every module that used to be IN that hardcoded
 * list (views/actions.ts, views/exec.ts, views/conflicts.ts, ws/strip.ts,
 * ws/notes.ts) now subscribes here instead, at its own module scope — see
 * each file's own doc comment for its subscription and, where relevant,
 * why it does NOT get one (ws/board.ts).
 *
 * A deliberate LEAF module (imports only createStore) so every
 * subscriber-side file above, AND state/workspace.ts (the notifier), can
 * import it without creating a circular import — state/workspace.ts still
 * imports views/actions.ts's renderActions directly for two UNRELATED,
 * deliberately-NOT-notify-routed single-target calls (init()'s pre-fetch
 * skeleton paint, switchAuthor()'s toolbar repaint) that were never part
 * of the fan-out this task decouples.
 *
 * A plain tick counter, not a snapshot of WS's own state: subscribers
 * always re-read whatever they need (payloadStore.get(), or the WS
 * singleton's own current fields via the bare global) when notified,
 * exactly like the old hardcoded fan-out always read the LATEST state at
 * call time rather than closing over a stale value. The counter's value
 * itself is never read by subscribers — it exists only so store.ts's
 * generic subscribe/notify plumbing has something to carry.
 */
import { createStore, type Store } from './store.ts';

export const wsChangeStore: Store<number> = createStore(0);

export function notifyWsChange(): void {
  wsChangeStore.update((n) => n + 1);
}
